import React, { Component } from 'react'
import MetaTags from '../../elements/meta/metaTags.js'
import { Columns, Container, Header } from '../../elements'
import { trackPageView } from '../../elements/tracking/pagesAndMarketingTracking.js'
import './insurance.css'

const optionStyle = {
  border: '1px solid #E8E8E8',
  padding: '1.25rem',
  height: '100%',
  textAlign: 'center',
  borderRadius: '6px',
}

class Insurance extends Component {
  componentDidMount() {
    window.scrollTo(0, 0)
    trackPageView('Insurance', 'Marketing')
  }

  render() {
    return (
      <Container className="medium">
        <MetaTags
          title={'Insurance & Protection at Twisted Road'}
          url={'/how-it-works/insurance'}
          description="We know that stuff can happen, so we’re covering you. We offer daily insurance rates to cover you. Your bike is safe and so are you! We cover damages that occur during the rental."
          type="company"
        />
        <Header renderas={'h1'} className="main-header has-text-centered has-text-weight-extra-bold mb-7">
          Twisted Road Insurance Protection
        </Header>
        <Columns className="is-centered mb-6">
          <Columns.Column size={6}>
            <Header renderas={'h2'} size={5} className="has-text-centered has-text-weight-bold">
              For Riders
            </Header>
            <p>
              We know that stuff can happen, so we’re covering you. We offer daily insurance rates to cover you for up
              to $40K of motorcycle damage that could happen during your ride and you’re automatically covered for minimum
              state liability on all plans.
            </p>
          </Columns.Column>
          <Columns.Column size={6}>
            <Header renderas={'h2'} size={5} className="has-text-centered has-text-weight-bold">
              For owners
            </Header>
            <p>
              <a href="/list-your-motorcycle"><strong>Your bike</strong></a> is safe and so are you! We cover damages that occur during the rental, for collision, up to the
              actual cash value of the bike (up to $40,000). You’re covered by $1Mil of liability insurance.
            </p>
          </Columns.Column>
          <Columns.Column size={6}>
            <Header renderas={'h2'} size={5} className="has-text-centered has-text-weight-bold">
              For international travelers
            </Header>
            <p>
              US insurance can be difficult to navigate, so we make it easy. We offer both damage and liability
              insurance that will cover you in the rare case that there is an incident. As long as you can prove you can
              legally ride a motorcycle in your home country, you can rent with us.
            </p>
          </Columns.Column>
        </Columns>
        <Header renderas={'h2'} size={5} className="has-text-centered has-text-weight-bold">
          Insurance Options
        </Header>
        <Columns breakpoint="mobile">
          <Columns.Column mobile={{ size: 12 }} tablet={{ size: 6 }} desktop={{ size: 3 }}>
            <div style={optionStyle}>
              <h2 className="has-text-weight-bold">Premium</h2>
              <div className="mb-3">Ride the world with the strongest protection plan</div>
              <ul className="fa-ul has-text-left is-size-7">
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $1,500 max out-of-pocket for damage ($2,500 for liability, theft, & total loss)
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $25K of damage coverage
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  State minimum liability insurance
                </li>
              </ul>
            </div>
          </Columns.Column>
          <Columns.Column mobile={{ size: 12 }} tablet={{ size: 6 }} desktop={{ size: 3 }}>
            <div style={optionStyle}>
              <h2 className="has-text-weight-bold">Standard</h2>
              <div className="mb-3">Relax and ride with solid coverage</div>
              <ul className="fa-ul has-text-left is-size-7">
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $2,500 max out-of-pocket for damage ($5,000 for liability, theft, & total loss)
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $25K of damage coverage
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  State minimum liability insurance
                </li>
              </ul>
            </div>
          </Columns.Column>

          <Columns.Column mobile={{ size: 12 }} tablet={{ size: 6 }} desktop={{ size: 3 }}>
            <div style={optionStyle}>
              <h2 className="has-text-weight-bold">Minimum</h2>
              <div className="mb-3">Basic coverage while saving money</div>
              <ul className="fa-ul has-text-left is-size-7">
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $3,000 max out-of-pocket for damage ($5,000 for liability, theft, & total loss)
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $25K of damage coverage
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  State minimum liability insurance
                </li>
              </ul>
            </div>
          </Columns.Column>
          <Columns.Column mobile={{ size: 12 }} tablet={{ size: 6 }} desktop={{ size: 3 }}>
            <div style={optionStyle}>
              <h2 className="has-text-weight-bold">High-Value</h2>
              <div className="mb-3">Our most expensive bikes require our high-value insurance plan. Enjoy the ride knowing you're covered.</div>
              <ul className="fa-ul has-text-left is-size-7">
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $3,500 max out-of-pocket for damage ($5,000 for liability, theft, & total loss)
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  $40K of damage and theft coverage
                </li>
                <li>
                  <span className="fa-li">
                    <i className="fad fa-check"></i>
                  </span>
                  State minimum liability insurance
                </li>
              </ul>
            </div>
          </Columns.Column>
        </Columns>
      </Container>
    )
  }
}

export default Insurance
